<template>
  <div class="loginPage">
    <div class="login-wrapper">
      <div>
        <!-- 微信扫码登录 -->
        <div v-show="activeId === 'wx'" class="wx-wrapper">
          <div id="wxwrapper" ref="wxwrapper"></div>
          <div class="wx-wrapper-tip">
            <i class="icon-wx"></i> 微信扫码登录
          </div>
        </div>
        <!-- 手机号登录 -->
        <div v-show="activeId === 'phone'" class="phone-wrapper" id="phonewrapper">
          <el-form ref="form" class="phoneLogin" :model="form" :rules="rules">
            <el-form-item prop="phone">
              <el-input v-model="form.phone" placeholder="手机号" maxlength="11">
                <span slot="prefix" class="icon phone"></span>
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <div class="code-wrap">
                <el-input v-model="form.code" placeholder="验证码">
                  <span slot="prefix" class="icon code"></span>
                </el-input>
                <el-button
                  class="send-btn"
                  :type="countdown>0?'default':'primary'"
                  size="mini"
                  :disabled="countdown>0"
                  @click="getCode"
                >{{countdown>0?(countdown+'S'):'获取验证码'}}</el-button>
              </div>
              <p class="tips fl" :class="{error:isError}" v-show="showTips">{{tipsMsg}}</p>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" type="primary" :loading="loginLoading" @click="login">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="switch-wrapper">
        <div
          v-for="it in loginOptions"
          class="icon"
          :class="`icon-${it.value} ${activeId === it.value ? 'active':''}`"
          :key="it.value"
          @click="toggleClick(it)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
// import '../../utils/wxLogin'
import { sendLoginSms, loginByPhone } from '@/api/user'
const webUrl = process.env.VUE_APP_WEB_URL
const serve1 = process.env.VUE_APP_SERVE_ONE
const serve2 = process.env.VUE_APP_SERVE_TWO
export default {
  name: 'login',
  components: {},
  props: {
    zoomValue: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      activeId: '',
      loginOptions: [
        {
          value: 'wx',
          label: '微信',
        },
        {
          value: 'qq',
          label: 'QQ',
        },
        // {
        //   value: 'ali',
        //   label: '支付宝',
        // },
        {
          value: 'phone',
          label: '手机号',
        },
      ],
      loadFail: false,
      countdown: 0,
      form: {
        code: '',
        phone: '',
      },
      showTips: false,
      loginLoading: false,
      isError: false,
      isGetCodeFlag: false,
      tipsMsg: '验证码已发送至您的手机',
      rules: {
        phone: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的手机号'))
              }
            },
          },
        ],
        code: [
          /*  {
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.countdown > 0) {
                callback()
              } else {
                callback(new Error('请先点击获取验证码'))
              }
            },
          }, */
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value) {
                if (/\d{6}/.test(value)) {
                  callback()
                } else {
                  this.showTips = false
                  callback(new Error('请输入正确的验证码'))
                }
              } else {
                this.showTips = false
                callback(new Error('请输入验证码'))
              }
            },
          },
        ],
      },
    }
  },
  created() {},
  mounted() {
    console.log(this.$route)
    this.toggleClick(this.loginOptions[0])
  },
  methods: {
    toggleClick({ value }) {
      if (this.activeId === value) return
      this.activeId = value
      switch (value) {
        case 'wx':
          this.getWxQrCode()
          break
        case 'qq':
          window.location.href =
            'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101919699&redirect_uri=' +
            serve2 +
            '/api/v1/user/gw/login_qq' +
            encodeURIComponent('?c_redirect=' + window.location.href)
          break
        case 'ali':
          window.location.href =
            'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021002117695095&scope=auth_user&redirect_uri=' +
            serve1 +
            '/api/v1/user/gw/login_ali' +
            encodeURIComponent('?c_redirect=' + window.location.href) +
            '&state=init'
          break
        case 'phone':
          break
      }
    },
    getWxQrCode() {
      try {
        this.loadFail = false
        new window.WxLogin({
          id: 'wxwrapper', //div的id
          appid: 'wx4bd16f9bf509ec6c',
          scope: 'snsapi_login', //写死
          redirect_uri: encodeURI(
            webUrl +
              'loginCallback?type=' +
              encodeURIComponent(window.location.href)
          ),
          state: '2531c949c4d828ab278c4fb94d81d440',
          style: 'black', //二维码黑白风格
          href:
            'data:text/css;base64,LmltcG93ZXJCb3ggLmluZm8gew0KICAgIGRpc3BsYXk6IG5vbmU7DQp9DQouaW1wb3dl' +
            'ckJveCAucXJjb2RlIHsNCiAgICB3aWR0aDogMTgwcHg7DQogICAgbWFyZ2luLXRvcDogMTVweDsNCiAgICBib3JkZXI6IDFweCBzb2' +
            'xpZCAjRTJFMkUyOw0KfQ0KLmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7DQogICAgZm9udC1zaXpl' +
            'OiAyMHB4Ow0KICAgIG1hcmdpbi10b3A6IDEwcHg7DQogICAgY29sb3I6d2hpdGU7DQp9', //nodejs 编译后的css脚本
        })
      } catch (error) {
        console.log(error)
        this.loadFail = true
        this.$refs.wxwrapper.innerHTML(`<p class="tips" v-show="loadFail">
                                          二维码加载失败,请点击
                                          <span class="refresh" onclick="${this.refresh}">刷新</span>
                                        </p>`)
      }
    },
    refresh() {
      this.getWxQrCode()
    },
    getCode() {
      if (this.countdown || this.isGetCodeFlag) return
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = null
      }
      this.isGetCodeFlag = true
      this.showTips = false
      this.$refs.form.validateField('phone', (valid) => {
        if (!valid) {
          sendLoginSms({
            phone: this.form.phone,
            send_type: '登录',
          })
            .then((res) => {
              if (res.code === 200) {
                this.countdown = 60
                this.timerId = setInterval(() => {
                  this.countdown--
                  if (this.countdown < 0) {
                    clearInterval(this.timerId)
                    this.timerId = null
                    this.countdown = 0
                  }
                }, 1000)
                this.isError = false
                this.tipsMsg = '验证码已发送至您的手机'
                this.$refs.form.clearValidate('code')
              } else {
                this.isError = true
                this.countdown = 0
                this.tipsMsg = '验证码获取失败'
              }
              this.showTips = true
            })
            .catch((err) => {
              this.countdown = 0
              let tipsMsg = '验证码获取失败'
              if (err && err.response && err.response.data) {
                this.isError = true
                tipsMsg = err.response.data.errmsg
              }
              this.tipsMsg = tipsMsg
              this.showTips = true
            }).finally(()=>{
              this.isGetCodeFlag = false
            })
        }
      })
    },
    login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loginLoading = true
          loginByPhone({ phone: this.form.phone, code: this.form.code })
            .then((res) => {
              if (res.code === 200) {
                this.$store.dispatch('user/setToken', res.token)
                this.$EventBus.$emit('login',res.user_info)
                // this.$store.commit('user/SET_USERINFO', res.user_info)
                this.$store.commit('app/setShowLogin', false)
                // window.location.reload()
              }
              this.loginLoading = false
            })
            .catch((err) => {
              let tipsMsg = err.data.info ? err.data.info : '登录失败'
              console.log(err)
              this.isError = true
              this.tipsMsg = tipsMsg
              this.showTips = true
              this.$refs.form.clearValidate('code')
              this.loginLoading = false
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__error{
  color: #e6a23c;
}
.loginPage {
  background-color: transparent;
  height: 100%;
  $width: 280Px;
  // $width: 100%;

  /* Chrome all / Safari all /opera15+*/
  -webkit-user-select: none;
  /* Firefox all */
  -moz-user-select: none;
  /* IE 10+ */
  -ms-user-select: none;
  /* 通用 */
  user-select: none;

  .login-wrapper {
    margin: auto;
    width: 280Px;
    min-height: 180Px;
    // background-color: rgba(0, 0, 0, .1);
    padding-top: 40Px;

    .field {
      font-size: 12Px;
      line-height: 20Px;
      color: #ff3030;
      margin: 0 0 0 10Px;
      text-align: left;
    }

    .tip-wrapper {
      text-align: left;
      clear: both;
      width: 250Px;
      margin-top: -10Px;
      font-size: 14Px;

      &.success {
        color: #28a6f6;
      }

      &.fail {
        color: #ff3030;
      }
    }

    .phone-wrapper {
      width: 240Px;
      margin: 0 auto;
      .phoneLogin {
        .icon {
          display: inline-block;
          width: 24Px;
          height: 24Px;
          margin-top: 7Px;
          &.phone {
            background-image: url('../../assets/icon/phone_blue.png');
          }
          &.code {
            background-image: url('../../assets/icon/icon_code_blue.png');
          }
        }
        .code-wrap {
          display: flex;

          .el-input {
            width: 120Px;
            margin-right: 20Px;
          }

          .send-btn {
            width: 100Px;
            color: #fff;

            &.is-disabled {
              color: #fff;
              border: none;
              font-size: 16Px;
              border: 1Px solid #eee;
              background-color: #fff;
            }
          }
        }
        .tips {
          width: 100%;
          text-align: right;
          color: #28a6f6;
          font-size: 12Px;
          line-height: 1;
          padding-top: 4Px;
          position: absolute;
          top: 100%;
          left: 0;
          &.error {
            color: #e6a23c;
          }
        }
        .el-button {
          border-color: #28a6f6;
          background-color: #28a6f6;
        }
        .login-btn {
          width: 100%;
          margin-bottom: 14Px;
        }
      }
    }

    .qq-wrapper {
      width: 240Px;
      height: 181Px;
      margin: 0 auto;
      display: none;
    }

    .wx-wrapper {
      width: 240Px;
      height: 200Px;
      margin: 0 auto;
      // display: none;

      .wx-wrapper-tip {
        font-size: 14Px;
        font-weight: 400;
        line-height: 19Px;
        color: #fff;
        text-align: center;
      }
      .icon-wx {
        display: inline-block;
        width: 24Px;
        height: 24Px;
        background-image: url('../../assets/icon/wx_green.png');
        background-size: 24Px 24Px;
        clear: both;
        vertical-align: -8Px;
      }

      /deep/ iframe {
        width: 220Px !important;
        height: 240Px !important;
        margin-top: -80Px;
      }
    }

    .switch-wrapper {
      width: 100%;
      height: 68Px;
      border-top: 1Px solid #dddddd;
      text-align: center;

      .icon {
        display: inline-block;
        width: 32Px;
        height: 32Px;
        background-size: 24Px 24Px;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 1;
        border-radius: 4Px;
        cursor: pointer;
        margin: 24Px 15Px 0 0;

        &:hover {
          background-color: #8fd3fe;
        }

        &:active,
        &.active {
          background-color: #28a6f6;
        }

        &.icon-wx {
          background-image: url('../../assets/icon/wx_green.png');

          &:hover {
            background-image: url('../../assets/icon/wx_white.png');
          }

          &:active,
          &.active {
            background-image: url('../../assets/icon/wx_white.png');
          }
        }

        &.icon-qq {
          background-image: url('../../assets/icon/qq.png');

          &:hover {
            background-image: url('../../assets/icon/qq_white.png');
          }

          &:active,
          &.active {
            background-image: url('../../assets/icon/qq_white.png');
          }
        }

        &.icon-ali {
          background-image: url('../../assets/icon/ali_gray.png');

          &:hover {
            background-image: url('../../assets/icon/ali_white.png');
          }

          &:active,
          &.active {
            background-image: url('../../assets/icon/ali_white.png');
          }
        }

        &.icon-phone {
          background-image: url('../../assets/icon/phone_blue.png');

          &:hover {
            background-image: url('../../assets/icon/phone_white.png');
          }

          &:active,
          &.active {
            background-image: url('../../assets/icon/phone_white.png');
          }
        }
      }
    }
  }
}
</style>
